var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page gc" },
    [
      _c("SideMenu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-content g9" },
        [
          _c("h2", [
            _vm._v(_vm._s(_vm.isActives ? "Active" : "Archived") + " Projects"),
          ]),
          _vm._v(" "),
          _c(
            "Accord",
            {
              attrs: {
                title: (_vm.isActives ? "Active" : "Archived") + " projects",
              },
            },
            [
              _c(
                "div",
                { staticClass: "grid-33w" },
                [
                  _vm._l(
                    _vm.projects.filter(function (x) {
                      return x.isArchived == !_vm.isActives
                    }),
                    function (project) {
                      return _c("ProjectTile", {
                        key: project.url,
                        attrs: { info: project },
                      })
                    }
                  ),
                  _vm._v(" "),
                  _vm.isActives
                    ? _c(
                        "div",
                        {
                          staticClass: "tile tile-project tile-project-create",
                        },
                        [
                          _c("p", { on: { click: _vm.onNewProjectClick } }, [
                            _vm._v(
                              "\n                        Create project\n                    "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        { ref: "modalNewProject", attrs: { title: "Create project" } },
        [
          _c("form", { on: { submit: _vm.onNewProjectSubmit } }, [
            _c("div", { staticClass: "input", attrs: { type: "text" } }, [
              _c("label", [
                _c("span", [_vm._v("Name")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newProjectName,
                      expression: "newProjectName",
                    },
                  ],
                  ref: "projectNameInput",
                  attrs: { type: "text", placeholder: "New project name" },
                  domProps: { value: _vm.newProjectName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newProjectName = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "right edit", class: { loading: _vm.isLoading } },
              [_vm._v("Create project")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }